<template>
  <div>
    <div class="card no-margin-bottom">
      <div class="card-block">
        <ui-data-table
          id="plans-list"
          ref="list"
          :columns="columns"
          :filters="filters"
          :endpoint="endpoint"
          :options="options"
          size="sm"
        >
          <template slot="id" slot-scope="row">
            {{ row.id }}
          </template>

          <template slot="log" slot-scope="row">
            <router-link class="text-primary"
              :to="{ name: 'InventoryLogsDetail', params: { log_id: row.id } }"
            >
            View
            </router-link>
          </template>

          <template slot="created_at" slot-scope="row">
            <span>{{ $getFormattedDate(row.created_at) }}</span>
          </template>

          <template slot="is_active" slot-scope="row">
            <i v-if="row.is_active" class="fa fa-check text-success" />
            <i v-else class="fa fa-remove text-danger" />
          </template>

          <template slot="actions" slot-scope="row">
            <a href="#" class="text-danger" @click.prevent="remove(row.id)">
              <i :title="$t('Delete')" class="fa fa-trash" />
            </a>
          </template>
        </ui-data-table>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import ApiService from "../services/ApiService";
import ErrorsMixins from "../mixins/ErrorsMixins";
import DateFormatFiltersMixin from "../mixins/DateFormatFiltersMixin";
export default {
  name: "AppPagePlans",
  mixins: [ErrorsMixins, DateFormatFiltersMixin],
  data() {
    return {
      columns: [
        {
          name: "ID",
          key: "id",
          sorting: true,
          styles: "text-right",
        },
        {
          name: this.$tc("Code", 1),
          key: "code",
          sorting: true,
        },
        {
          name: this.$tc("Name", 1),
          key: "name",
          sorting: true,
        },
        {
          name: this.$tc("Vendor Id", 1),
          key: "vendor_id",
          sorting: true,
        },
        {
          name: this.$tc("Logs", 2),
          key: "log",
          sorting: true,
        },
      ],
      filters: [
        {
          name: "ID",
          key: "id",
          type: "integer",
        },
        {
          name: this.$tc("Code", 1),
          key: "code",
          type: "string",
        },
        {
          name: this.$tc("Name", 1),
          key: "name",
          type: "string",
        },
        {
          name: this.$tc("Vendor Id", 1),
          key: "vendor_id",
          type: "string",
        },
      ],
      endpoint: `${ApiService.getLink("vendors/warehouses")}&account_id=${
        this.$route.params.id
      }&columns=code,id,name,vendor_id&includes=historyThirdParty`,
      options: {searchable: true,},
    };
  },
  methods: {
    refresh() {
      this.$refs.list.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.role-badge {
  margin-right: 3px;
}
</style>
